<template>
  <div>
    <a-card style="width: 100%; text-align: center">
      <div class="table-page-search-wrapper">
        <a-form layout="inline"
                style="margin: 20px 0px 0px 20px">
          <a-row :gutter="12">
            <a-col :md="6"
                   :sm="12">
              <a-form-item label="处理人">
                <a-input v-model="query.disposeName"
                         placeholder="请输入处理人"
                         allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6"
                   :sm="12">
              <a-form-item label="设备编码">
                <a-input v-model="query.flowMeterNo"
                         placeholder="请输入设备编码"
                         allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6"
                   :sm="12">
              <a-form-item label="报警级别">
                <a-select placeholder="请选择报警级别"
                          v-model="query.alarmLevel"
                          allow-clear>
                  <a-select-option value="报警"> 报警 </a-select-option>
                  <a-select-option value="预警"> 预警 </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6"
                   :sm="12">
              <a-form-item label="处理状态">
                <a-select placeholder="请选择处理状态"
                          v-model="query.isDispose"
                          allow-clear>
                  <a-select-option :value="0"> 未处理 </a-select-option>
                  <a-select-option :value="1"> 已处理 </a-select-option>
                  <a-select-option :value="2"> 已忽略 </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <!-- <a-col :md="6" :sm="12">
              <a-form-item label="处理状态">
                <a-select placeholder="请选择处理状态" v-model="query.disposeResult" @change="handleChangeleve">
                  <a-select-option v-for="(item, index) in resultType" :key="index" :value="item">
                    <span v-if="item == 0">待处理</span>
                    <span v-else>已处理</span>
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col> -->
            <a-col :md="6"
                   :sm="12"
                   style="display: flex">
              <a-form-item>
                <a-button type="primary"
                          @click="queryList">查询</a-button>
              </a-form-item>
              <a-form-item style="margin-left: 12px">
                <a-button @click="resetList">重置</a-button>
              </a-form-item>
              <a-button type="danger"
                        style="margin-left: 12px"
                        @click="deleteSelectRow()">删除</a-button>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <a-table rowKey="id"
               :scroll="{ x: 2000 }"
               :columns="columns"
               :data-source="list"
               :row-selection="{ selectedRowKeys: this.selectedRows, onChange: onSelectChange }"
               :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
               :pagination="pagination"
               @change="pageChange"
               bordered>
        <span slot="prewarningValue"
              slot-scope="text"
              v-if="text !== null">{{ moment(text).toFixed(3) }} </span>
        <span slot="type"
              slot-scope="text">
          <span v-if="text == 0">报警</span>
          <span v-else>故障</span>
        </span>
        <span slot="actiontype"
              slot-scope="text">
          <span v-if="text == 0"><a-tag color="rgb(255, 99, 71)">未处理</a-tag></span>
          <span v-else-if="text == 1"><a-tag color="rgb(50, 205, 50)">已处理</a-tag></span>
          <a-tag color="#1890ff"
                 v-else> 已忽略 </a-tag>
        </span>
        <span slot="malfunctionLevel"
              slot-scope="text">
          <a-tag color="rgb(255, 0, 0)"
                 v-if="text == '报警'"> 报警 </a-tag>
          <a-tag color="rgb(255, 165, 0)"
                 v-else-if="text == '预警'"> 预警 </a-tag>
        </span>
        <span slot="Operation"
              slot-scope="text, record">
          <a @click="PublishTask(record)"
             :disabled="record.isDispose !== 0">处理</a>
          <a style="margin-left: 12px"
             :disabled="record.isDispose !== 0"
             @click="LoseSightOf(record.id)">忽略</a>
        </span>
      </a-table>
      <!-- <a-modal
        title="标记报警级别"
        okText="标记"
        width="50%"
        :visible="visible"
        :confirm-loading="confirmLoading"
        @ok="handleOk"
        @cancel="handleCancel"
      >
        <a-form :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
          <a-select v-model="level" @change="handleChange" >
            <a-select-option v-for="(item, index) in typelist" :key="index" :value="item">
              {{ item }}
            </a-select-option>
          </a-select>
        </a-form>
      </a-modal> -->
      <a-modal title="处理报警"
               okText="处理"
               width="50%"
               :visible="showdeal"
               @ok="handleDealOk"
               @cancel="handleDealCancel">
        <a-form :form="form"
                :label-col="{ span: 5 }"
                :wrapper-col="{ span: 12 }">
          <a-form-item label="处理人">
            <a-input v-decorator="['disposeName', { rules: [{ required: true, message: '请输入处理人!' }] }]" />
          </a-form-item>
          <a-form-item label="报警描述">
            <a-input v-decorator="['alarmContent', { rules: [{ required: true, message: '请输入报警描述!' }] }]" />
          </a-form-item>
        </a-form>
      </a-modal>
    </a-card>
    <task-modal ref="TaskModal"
                @handleOk="update"></task-modal>
  </div>
</template>

<script>
import mixinViewModule from '@/mixin/common'
import TaskModal from '@/views/maintenance/TaskManagement/modules/TaskModal'
import moment from 'moment'
export default {
  components: {
    TaskModal,
  },
  mixins: [mixinViewModule],
  data () {
    return {
      id: '',
      level: '选择报警级别',
      showdeal: false,
      queryUrl: '/pipe-network/remote_water_meter_alarm_messages/page',
      deleteUrl: '/pipe-network/remote_water_meter_alarm_messages/',
      modifyUrl: '/pipe-network/remote_water_meter_alarm_messages',
      visible: false,
      confirmLoading: false,
      list: [],
      query: {
        flowMeterName: '',
        disposeName: '',
        alarmLevel: '',
        flowMeterNo: '',
        isDispose: 0,
        sysTab: 1,
        tenantId: this.$store.state.user.info.tenantId,
      },
      resultType: [0, 1],
      typelist: ['重要', '中等', '一般'],
      form: this.$form.createForm(this, { name: 'coordinated' }),
      columns: [
        {
          title: '序号',
          dataIndex: '',
          key: 'rowIndex',
          width: 70,
          align: 'center',
          customRender: function (t, r, index) {
            return parseInt(index) + 1
          },
        },
        {
          title: '设备编号',
          width: 150,
          dataIndex: 'flowMeterNo',
          align: 'center',
        },
        {
          title: '报警位置',
          width: 150,
          dataIndex: 'msgAddress',
          align: 'center',
          ellipsis: true,
        },
        {
          title: '报警级别',
          width: 100,
          dataIndex: 'alarmLevel',
          align: 'center',
          scopedSlots: { customRender: 'malfunctionLevel' },
        },
        {
          title: '处理状态',
          width: 100,
          dataIndex: 'isDispose',
          align: 'center',
          scopedSlots: { customRender: 'actiontype' },
        },

        {
          title: '开始报警时间',
          width: 200,
          dataIndex: 'createTime',
          align: 'center',
        },
        {
          title: '最近一次报警时间',
          width: 200,
          dataIndex: 'updateTime',
          align: 'center',
        },
        {
          title: '报警类型',
          width: 100,
          dataIndex: 'alarmType',
          align: 'center',
          // scopedSlots: { customRender: 'type'},
        },
        {
          title: '报警指标',
          width: 100,
          dataIndex: 'alarmIndex',
          align: 'center',
        },
        {
          title: '指标当前报警值',
          width: 150,
          dataIndex: 'prewarningValue',
          align: 'center',
          // scopedSlots: { customRender: 'prewarningValue' },
        },
        {
          title: '参考值',
          width: 100,
          dataIndex: 'refValue',
          align: 'center',
        },
        {
          title: '报警次数',
          width: 100,
          dataIndex: 'num',
          align: 'center',
        },
        {
          title: 'X坐标',
          width: 150,
          dataIndex: 'longitude',
          align: 'center',
        },
        {
          title: 'Y坐标',
          width: 150,
          dataIndex: 'latitude',
          align: 'center',
        },
        {
          title: '处理人',
          width: 100,
          dataIndex: 'disposeName',
          align: 'center',
        },
        {
          title: '处理时间',
          width: 200,
          dataIndex: 'disposeTime',
          align: 'center',
        },
        {
          title: '操作',
          width: 130,
          fixed: 'right',
          dataIndex: 'id',
          align: 'center',
          scopedSlots: { customRender: 'Operation' },
        },
      ],
    }
  },
  computed: {
    title () {
      return `${this.$store.getters.userInfo.tenant.shortName}智慧管理平台`
    },
    currentUser () {
      return this.$store.getters.userInfo
    },
    token () {
      return this.$store.getters.token
    },
  },
  created () { },
  methods: {
    moment,
    PublishTask (record) {
      this.currentId = record.id
      this.$refs.TaskModal.edit(record)
    },
    update () {
      let data = {
        id: this.currentId,
        isDispose: 1,
      }
      this.$http.put('/pipe-network/remote_water_meter_alarm_messages', data).then(({ data }) => {
        this.queryList()
      })
    },
    LoseSightOf (id) {
      let params = {
        id: id,
        isDispose: 2,
      }
      console.log(id, 'ddd')
      this.$confirm({
        title: '忽略',
        content: `您确定要忽略此条数据吗？`,
        centered: true,
        onOk: () => {
          this.$http.put('/pipe-network/remote_water_meter_alarm_messages', params).then((res) => {
            this.isDispose == 2
            this.queryList()
            this.$message.success(`忽略此条数据成功！`)
          })
        },
      })
    },
    resetList () {
      console.log('reset')
      this.query = {
        flowMeterName: '',
        disposeName: '',
        isDispose: 0,
        sysTab: 1,
        alarmLevel: '',
        flowMeterNo: '',
        tenantId: this.$store.state.user.info.tenantId,
      }
      this.pagination.current = 1
      this.selectedRows = []
      this.queryList()
      // this.loadData()
    },
    handleChangeleve (e) {
      this.query.disposeResult = e
    },
    handleChange (e) {
      let params = { id: this.id, malfunctionLevel: e }
      const header = {
        'Content-Type': 'application/json',
        Authorization: this.token,
      }
      this.$http({
        url: this.modifyUrl,
        data: params,
        headers: header,
        method: 'put',
      }).then((data) => {

        this.queryList()
        this.visible = false
        this.level = '选择报警级别'
        this.$message.success('标记成功')
      })
    },
    handleSelectChange (value) {
      console.log(value)
      this.form.setFieldsValue({ isDispose: value })
    },
    handleDealSelectChange (value) {
      console.log(value)
      this.form.setFieldsValue({
        disposeResult: value,
      })
      // this.addOrUpdateForm.setFieldsValue(value)
    },
    // handleDealSelectChange(value) {
    //   console.log(value)
    //   this.form.setFieldsValue({
    //     processMode: value,
    //   })
    // },
    Deal (id) {
      this.id = id
      // this.addOrUpdateHandle(id);
      this.showdeal = true
    },
    addOrUpdateHandle (id) {
      this.id = id
      this.showModal()
    },
    showModal () {
      this.visible = true
    },
    handleDealOk () {
      console.log(this.id)
      this.form.validateFields((err, values) => {
        if (!err) {
          let year = new Date().getFullYear()
          let month = new Date().getMonth() + 1
          month = month < 10 ? '0' + month : month
          let day = new Date().getDate()
          day = day < 10 ? '0' + day : day
          let hour = new Date().getHours()
          hour = hour < 10 ? '0' + hour : hour
          let seconds = new Date().getSeconds()
          seconds = seconds < 10 ? '0' + seconds : seconds
          let minutes = new Date().getMinutes()
          minutes = minutes < 10 ? '0' + minutes : minutes
          let now = year + '-' + month + '-' + day + ' ' + hour + ':' + minutes + ':' + seconds
          let params = {
            id: this.id,
            disposeName: values.disposeName,
            alarmContent: values.alarmContent,
            isDispose: 1,
            // processMode: values.processMode,
            // disposeResult:values.disposeResult,
            // disposeResult: 1,
            disposeTime: now,
          }
          const header = {
            'Content-Type': 'application/json',
            Authorization: this.token,
          }
          this.$http({
            url: this.modifyUrl,
            data: params,
            headers: header,
            method: 'put',
          }).then((data) => {

            this.queryList()
            this.showdeal = false
            this.form.resetFields()
            this.$message.success('处理成功')
          })
        }
      })
    },
    handleDealCancel () {
      this.showdeal = false
    },
    handleOk () {
      this.visible = false
    },
    handleCancel (e) {
      this.visible = false
    },
  },
}
</script>

<style lang="less" scoped>
/deep/.table-striped {
  background-color: #fafafa;
}
</style>